import React, { Component } from "react";
import bttnU from "../../../assets/mobileAssets/upload.svg";
import bttnC from "../../../assets/mobileAssets/camera.svg";
class UploadBttnMob extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let icon, text;
    if (this.props.type === 1) {
      icon = bttnU;
      text = "Upload";
    } else {
      icon = bttnC;
      text = "Camera";
    }
    return (
      <div
        style={{
          padding: "0px",
          border: "0px",
          backgroundColor: "#17D9AA",
          boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
          borderRadius: "3px",
          outline: "none",
          width: "118px",
          height: "40px",
          color: "#232D43",
          fontSize: "14px",
          fontFamily: "Helvetica",
          fontStyle: "normal",
          fontWeight: "300",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img src={icon} alt="add" style={{ paddingRight: "5px" }} />
        {text}
      </div>
    );
  }
}

export default UploadBttnMob;
